import React, { useEffect, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { styles } from './index.styles';

const Bar = ({
  actionCount,
  bigText = false,
  label,
  max,
  noAnimation = false,
  onSelect,
  selected = false,
}) => {
  const [width, setWidth] = useState(0);

  // trigger a fancy css transition delay
  useEffect(() => {
    setWidth((actionCount / max) * 100);
  }, [actionCount, max]);

  return (
    <Stack
      direction="row"
      onClick={onSelect}
      sx={styles.barWrapper(!!onSelect, selected)}
    >
      <Box sx={styles.label}>
        <Typography
          sx={{
            fontSize: bigText ? 25 : 16,
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box
        className="statistics-bar__value"
        sx={{
          flexGrow: 1,
        }}
      >
        <Box
          data-test-id="yellow-bar"
          sx={{
            width: `${
              noAnimation
                ? actionCount === 0
                  ? 0
                  : (actionCount / max) * 100
                : width
            }%`,
            ...styles.bar,
          }}
        />
      </Box>
      <Box sx={styles.counter}>
        <Typography sx={{ fontSize: bigText ? 25 : 16 }}>
          {actionCount}
        </Typography>
      </Box>
    </Stack>
  );
};

Bar.propTypes = {
  actionCount: PropTypes.number.isRequired,
  bigText: PropTypes.bool,
  label: PropTypes.string.isRequired,
  max: PropTypes.number.isRequired,
  noAnimation: PropTypes.bool,
  onSelect: PropTypes.func,
  selected: PropTypes.bool,
};

export default Bar;
